module.exports = __webpack_public_path__ + "img/18.0a8b8140.jpg";